import React, {useEffect, useState} from 'react';
import {getFilterProductLine} from "../../microComponents/tablePages/getFilterProductLine";
import GetProductList from "../Products/GetProductList";
import FilterSelectOption from "../../microComponents/tablePages/filter/FilterSelectOption";
import DebouncingInputFilter from "../../microComponents/tablePages/filter/DebouncingInputFilter";
import DateFilter from "../../microComponents/tablePages/filter/DateFilter";


const TopSearchSeriesHistory = () => {

    const [productList, setProductList] = useState([]);
    const [productListLoading, setProductListLoading] = useState(false);
    const [filterProductLine, setFilterProductLine] = useState([]);
    const [productLineLoading, setProductLineLoading] = useState(false);


    useEffect(() => {
        GetProductList(setProductList, setProductListLoading)
        getFilterProductLine(setFilterProductLine, setProductLineLoading)

    }, [])
    return (<div className='grid grid-cols-1 2xs:grid-cols-2 sm:grid-cols-3 md:grid-cols-4   gap-x-4  gap-y-5 mt-10   '>

        <FilterSelectOption data={{
            filterName: 'productLine',
            className: '2xs:hidden',
            loading: productLineLoading,
            placeholder: 'خط تولید',
            options: filterProductLine
        }}/>
        <FilterSelectOption data={{
            filterName: 'product',
            className: 'sm:hidden',
            loading: productListLoading,
            placeholder: 'کالا',
            options: productList
        }}/>

        <DebouncingInputFilter
            data={{
                className: 'lg:hidden',
                placeholder: 'سرپرست تولید',

                filterName: 'seriCreateBy',
            }}
        />


        <DateFilter
            data={{
                className: 'lg:hidden',
                placeholder: ['زمان ثبت تا', 'زمان ثبت از'],
                filterName: ['fromCreateDate', 'toCreateDate'],
            }}
        />


    </div>);
};

export default TopSearchSeriesHistory;
